import { render, staticRenderFns } from "./ExpandableCard.vue?vue&type=template&id=1648eaf1&scoped=true"
import script from "./ExpandableCard.vue?vue&type=script&lang=js"
export * from "./ExpandableCard.vue?vue&type=script&lang=js"
import style0 from "./ExpandableCard.vue?vue&type=style&index=0&id=1648eaf1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1648eaf1",
  null
  
)

export default component.exports